import axios from 'axios';
import { getApiUrl } from '../../../config';

export const getBillingRetainers = () => {
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/retainers`,
        withCredentials: true,
        crossorigin: true
    });
};

export const saveBillingRetainerTerms = (entityType, entityId, billingTerms) => {
    return axios.request({
        method: 'PUT',
        url: `${getApiUrl()}/billing/retainers/${entityType}/${entityId}`,
        data: { billingTerms },
        withCredentials: true,
        crossorigin: true
    });
};

export const getRetainerStatus = ({ accountId, clientId }) => {
    const params = {};
    if (accountId) params.account = accountId;
    if (clientId) params.client = clientId;
    return axios.request({
        method: 'GET',
        url: `${getApiUrl()}/billing/retainers/status`,
        params,
        withCredentials: true,
        crossorigin: true
    });
};
